import styled from 'styled-components';

export const TestCyclesOverviewFiltersStyled = styled.div`
  z-index: 2;
  position: relative;
  display: flex;
  align-items: center;
`;

export const TestCyclesOverviewProjectSelectStyled = styled.div`
  margin-top: -8px !important;
`;

export const TestCyclesOverviewFiltersColumnStyled = styled.div<{
  fillContainer?: boolean;
  size?: 'small' | 'medium' | 'large';
}>`
  align-items: center;
  margin-right: 10px;

  ${({ fillContainer }) => !!fillContainer && 'width: 100%;'}

  ${({ size }) => {
    let maxWidth = 'auto';
    let minWidth = 'auto';
    switch (size) {
      case 'small':
        minWidth = `140px`;
        maxWidth = `180px`;
        break;
      case 'medium':
        minWidth = `180px`;
        maxWidth = `240px`;
        break;
      case 'large':
        minWidth = `300px`;
        maxWidth = `360px`;
        break;
    }

    return `
      min-width: ${minWidth};
      max-width: ${maxWidth};
    `;
  }}

  &:last-of-type {
    margin-right: 0;
  }
`;
